import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報コピークラス
 *
 * @export RegistGoodsBaseCopyService
 * @class RegistGoodsBaseCopyService
 * @extends {PlessResponder}
 */
@Injectable()
export class RegistGoodsBaseCopyService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistGoodsBaseCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo[0],
        JanCode: this.vo[1],
        CopySpecFlag: this.vo[2]
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistGoodsBaseCopyService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registGoodsBaseCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistGoodsBaseCopyService
   */
  success(data: any): void {
    // 検索ボタンの表示設定。初期化する
    this.model.kymw1100Component.setWindowVisible('SEACH');

    // P情報
    this.model.updateGoodsBaseData(data);

    // コピーの排他制御を行う。
    this.model.kymw1100Component.eventLockCopy();

    this.model.updateMarkCodeList(data);

    this.model.updateTextInfoList(data);

    this.model.updateListingList(data);

    // item情報
    this.model.updateGoodsDatailData(data);

    this.model.updateGoodsCoopList(data);
    // 商品DNA情報更新
    this.model.updateGoodsDnaList(data);

    this.model.updateGoodsCoopWkList(data);

    this.model.updateSpecifications1List(data);

    this.model.updateGoodsAllergenList(data);

    this.model.updateGoodsNutrientInfo(data);

    this.model.updateGoodsEcologyList(data);

    this.model.updateGoodsGWStopList(data);

    this.model.updateContainPackingList(data);

    this.model.enabledGoodsKYMW1104Flg = false;

    this.model.setTagInfo(data);

    this.model.setPublishMediumInfo(data);

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
